/**
 * Item History Model - Encapsulates item history data
 */
class ItemHistoryModel {
    private _serverData: any;

    constructor(serverData: any = null) {
        this._serverData = serverData;
    }

    // ===== SERVER DATA PROPERTIES =====

    get date_time() {
        return this._serverData?.date_time ?? '';
    }

    get item_name() {
        return this._serverData?.item_name ?? '';
    }

    get scan_code() {
        return this._serverData?.scan_code ?? '';
    }

    get type() {
        return this._serverData?.type ?? '';
    }

    get old_price() {
        return this._serverData?.old_price ?? 0;
    }

    get new_price() {
        return this._serverData?.new_price ?? 0;
    }

    get status() {
        return this._serverData?.status ?? '';
    }

    get updated_by() {
        return this._serverData?.updated_by ?? '';
    }

    // ===== FORMATTED PROPERTIES =====

    get formattedDateTime() {
        // Basic formatting, can be enhanced with date-fns or similar if available/needed
        // For now returning ISO string or raw value if not parseable
        return this.date_time || '-';
    }

    get formattedOldPrice() {
        return this._formatCurrency(this.old_price);
    }

    get formattedNewPrice() {
        return this._formatCurrency(this.new_price);
    }

    // ===== UI FORMAT (for table rows) =====

    toRowFormat() {
        return {
            date: this.date_time,
            type: this.type,
            updatedBy: this.updated_by,
            oldPrice: this.old_price,
            newPrice: this.new_price,
            status: this.status,
        };
    }

    // ===== HELPER METHODS =====

    _formatCurrency(value: number | null | undefined): string {
        if (value === null || value === undefined) {
            return '0.00';
        }
        return Number(value).toFixed(2);
    }

    // ===== UTILITY METHODS =====

    getRawData() {
        return this._serverData;
    }

    // ===== STATIC METHODS =====

    static fromServerData(serverData: any) {
        return new ItemHistoryModel(serverData);
    }

    static createEmpty() {
        return new ItemHistoryModel();
    }
}

export default ItemHistoryModel;
